import ClipboardJS from 'clipboard';
import util from '@utils/util';
import Toast from '../../toast/live';
export default {
  name: 'share',
  data: function data() {
    return {
      // / toast 提示。
      toastMessage: '',
      toastVisible: false
    };
  },
  props: {
    text: {
      type: String,
      default: 'LiveMe'
    },
    url: {
      type: String,
      default: window.location.href
    }
  },
  components: {
    toast: Toast
  },
  mounted: function mounted() {
    var _this = this;
    this.clipboard = new ClipboardJS(this.$refs.copylinkTrigger);
    this.clipboard.on('success', function () {
      _this.toastMessage = 'success';
      _this.toastVisible = true;
      // 进行大数据 分享 上报
      _this.ldcTrack('copylink');
      setTimeout(function () {
        _this.toastVisible = false;
      }, 2000);
    });
    this.clipboard.on('error', function () {
      _this.toastMessage = 'error';
      _this.toastVisible = true;
      setTimeout(function () {
        _this.toastVisible = false;
      }, 2000);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.clipboard) {
      this.clipboard.destroy();
      this.clipboard = null;
    }
  },
  methods: {
    ldcTrack: function ldcTrack(action) {
      var schTypeJson = {
        facebook: 1,
        instagram: 2,
        copylink: 3,
        电子邮件: 4,
        讯息: 5,
        twitter: 6,
        wechat: 7,
        我的家族: 8,
        line: 9,
        kik: 10,
        vk: 11,
        whatsapp: 12,
        skype: 13,
        pinterest: 14,
        snapchat: 15,
        messenger: 16
      };
      // 直播 分享事件 大数据上报
      var ldcC = window.localStorage.getItem('ldcC');
      var ldcD = window.localStorage.getItem('ldcD');
      // const vdoid = window.localStorage.getItem('ldcVid');

      util.ldcTrack({
        act: 5,
        c: ldcC || '',
        d: ldcD,
        sch: schTypeJson[action]
      });
    },
    shareHandler: function shareHandler(action) {
      util.KEWLSensorTrack({
        lmweb_clickText: '分享',
        lmweb_tabName: action
      });
      // 进行大数据 分享 上报
      this.ldcTrack(action);
      switch (action) {
        case 'facebook':
          this.shareOpenWindow("https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(util.addQueryStringParameter(this.url, 'webshare', 'facebook'))), 600, 450);
          break;
        case 'twitter':
          this.shareOpenWindow("https://twitter.com/intent/tweet?text=".concat(encodeURIComponent(this.text), "&url=").concat(encodeURIComponent(util.addQueryStringParameter(this.url, 'webshare', 'twitter'))), 600, 450);
          break;
        case 'line':
          this.shareOpenWindow("https://social-plugins.line.me/lineit/share?url=".concat(encodeURIComponent(util.addQueryStringParameter(this.url, 'webshare', 'line'))), 600, 450);
          break;
        default:
          break;
      }
    },
    shareOpenWindow: function shareOpenWindow(url) {
      var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;
      var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 450;
      // eslint-disable-next-line no-restricted-globals
      var left = Math.floor((screen.width - width) * 0.5);
      // eslint-disable-next-line no-restricted-globals
      var top = Math.floor((screen.height - height) * 0.5);
      var otherWindow = window.open(url, 'share', "left=".concat(left, ", top=").concat(top, ", width=").concat(width, ", height=").concat(height, ", scrollbars=no"));
      if (otherWindow) {
        otherWindow.opener = null;
      }
    }
  },
  created: function created() {
    var _this2 = this;
    this.$lmBus && this.$lmBus.$on('Live-Click-Share-Handle', function () {
      _this2.url = window.location.href;
    });
  }
};